module.exports = "https://cdn-web.ertelecom.ru/b2c-domru/frontend/_next/static/images/Tv_mpbile-2f76ca20d64523ffacef471fed03a739.png";